namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_tools, {
		
		// Hide_head_tools: {
		// 	boxShadow: '0 -1px 0 0 var(--mol_theme_line)',
		// },

		Delete: {
			margin: {
				left: '2rem',
			},
			color: '#ff6666',
		},

		// Settings_trigger_icon: {
		// 	width: '1.25rem',
		// 	height: '1.25rem',
		// },

		Settings_widget_enabled_icon: {
			width: '1.25rem',
			height: '1.25rem',
		},
		
	} )
	
}
